import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { limitCustomersSelect } from 'utils/common';
import classes from './CheckBox.module.scss';

const CheckBox = ({
  company,
  handleCheck,
  isSelected,
  allCheck,
  selectedCustomers
}) => {
  const handleSelectBox = company => {
    if (!selectedCustomers) return handleCheck(company);
    if (selectedCustomers >= limitCustomersSelect && isSelected)
      return handleCheck(company);
    if (selectedCustomers >= limitCustomersSelect && !isSelected) return null;
    if (selectedCustomers <= limitCustomersSelect) return handleCheck(company);
  };

  return (
    <>
      {allCheck === 'none' ? (
        <div className={classes.nullContainer}></div>
      ) : (
        <div
          className={cn(classes.optionWrap)}
          onClick={() => handleSelectBox(company)}
        >
          <div
            className={cn(
              classes.checkBox,
              (isSelected || allCheck === 'all') && classes.checkBox_selected
            )}
          >
            {allCheck === 'all' ? (
              <div className={classes.arrow} />
            ) : allCheck === '-' ? (
              '-'
            ) : (
              isSelected && <div className={classes.arrow} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

CheckBox.propTypes = {
  company: PropTypes.object,
  handleCheck: PropTypes.func.isRequired,
  isSelected: PropTypes.object,
  allCheck: PropTypes.string,
  selectedCustomers: PropTypes.number
};

export default CheckBox;
